// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscribe-hero-2026-ai-partners__list[data-v-6a54b7ed]{gap:.8rem 1.2rem}@media(min-width: 992px){.subscribe-hero-2026-ai-partners__list[data-v-6a54b7ed]{gap:1.6rem}}.subscribe-hero-2026-ai-partners__item img[data-v-6a54b7ed]{height:24px}@media(min-width: 992px){.subscribe-hero-2026-ai-partners__item img[data-v-6a54b7ed]{height:30px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
